var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid"},[_c('div',{staticClass:"grid__container"},[_c('div',{staticClass:"grid__content"},[_vm._t("default")],2),(_vm.$slots.aside)?_c('div',{staticClass:"grid__aside"},[_vm._t("aside")],2):_vm._e()]),(_vm.$slots.bottom)?_c('div',{staticClass:"grid__bottom"},[_vm._t("bottom")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }